import styled, { css } from "styled-components";

const controlSize = "30px";

const arrowControlMixin = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${controlSize};
  height: ${controlSize};
  border-radius: 50%;
  border: none;
  margin: 0 4px;
  background-color: ${({ theme }) => theme.colors.colorsNew.base.transparent};
  cursor: inherit;
  svg > path {
    fill: ${({ theme }) => theme.colors.colorsNew.gray[600]};
  }
`;

export const Wrapper = styled.div<{ hidden: boolean }>`
  display: flex;
  height: min-content;
  align-items: center;

  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `}

  .pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &__prev svg {
      transform: rotate(180deg);
    }

    &__prev,
    &__next {
      cursor: pointer;
      &[aria-disabled="true"] {
        cursor: not-allowed;
        svg > path {
          fill: ${({ theme }) => theme.colors.colorsNew.gray[400]};
        }
      }
    }

    &__control {
      ${arrowControlMixin}
    }

    &__link {
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${controlSize};
      height: ${controlSize};
      border-radius: 50%;
      cursor: pointer;
      margin: 0 4px;
      background: ${({ theme }) => theme.colors.colorsNew.base.transparent};
      font-weight: ${({ theme }) => theme.fontWeight.semiBold};
      color: ${({ theme }) => theme.colors.colorsNew.gray[600]};
    }

    & .selected {
      a {
        background: ${({ theme }) => theme.colors.colorsNew.blue.blue};
        color: ${({ theme }) => theme.colors.colorsNew.base.white};
        cursor: default;
      }
    }
  }
`;
